
<template>
  <div style="padding-top: 20px;">
    <div class="buy-center">
      <div class="container" style="background:#fff;padding: 20px;">
        <div class="title">
          <img :src="require(`@/assets/images/product/logo_${utils.getProductCode()}.png`)" alt />
          <h3>{{`${softPrice.softName}`}}</h3>
          <span class="tag">{{licenseTypeName}}</span>
          <router-link :to="{path:'/price'}" style="font-size:14px;padding:5px 10px;color:#999;">
            <span>切换版本</span>
          </router-link>
        </div>
        <div style="border-bottom:1px solid rgba(0, 0, 0, 0.1);"></div>
        <!-- ===================================购买选项插槽=================================== -->
        <slot name="center"></slot>
        <!-- ===================================订单金额=================================== -->
        <div>
          <div style="font-size: 14px;" class="my-font-lg my-type-info">
            <span v-loading="loadingCalc">
              <span style="color: #F56C6C;font-size: 12px;">￥</span>
              <span style="color: #F56C6C; font-weight: bold; font-size: 22px;">{{amount.toFixed(2)}}</span>
            </span>
            <span
              v-if="originalAmount>amount"
              style="font-size: 12px; text-decoration:line-through;color:#999; margin-left: 10px;"
            >原价￥{{originalAmount.toFixed(2)}}</span>
          </div>
          <div>
            <div class="my-flex my-m-t-10">
              <div
                v-loading="loadingSubmit"
                @click="$emit('submit')"
                class="btn2"
                :style="{background:`linear-gradient(306deg, rgba(${utils.hexToRgb(softPrice.softThemeColor)},0.5), rgba(${utils.hexToRgb(softPrice.softThemeColor)},1))`}"
              >提交订单</div>
              <div class="my-flex-1">
                <!-- <span v-if="bookInfo.tenantAccount" class="my-font-xs my-type-info my-m-l-10">当前账号：</span>
                <span v-if="bookInfo.tenantAccount" class="my-font-xs my-type-info">{{ bookInfo.tenantAccount }}（{{ bookInfo.company }}）</span>-->
                <contact-service :width="200" titleSize="12" type="dialog">
                  <span class="my-m-l-10 my-font-sm my-type-primary">联系客服</span>
                </contact-service>
              </div>
            </div>
            <div class="my-flex"></div>
          </div>
        </div>
        <!-- ===================================各版本区别=================================== -->
        <version-diff
          v-if="licenseType == 'Network'&& versionList.length>1&& diffList.length>0"
          class="my-m-t-20"
          v-loading="loading"
          :dataList="diffList"
          :versions="versionList"
          :hasFreeVersion="utils.getProductCode()=='ES'"
          @buyVersion="$emit('buyVersion',$event)"
        />
        <!-- ===================================专业版权益=================================== -->
        <intros v-loading="loading" :dataList="introList" />
      </div>
    </div>
  </div>
</template>

<script>
import API_Soft from '@/api/soft'
import versionDiff from '@/_myComponents/versionDiff.vue'
import intros from '@/_myComponents/intros.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    versionDiff,
    intros
  },
  name: '',
  props: {
    licenseType: {
      type: String,
      default: ''
    },
    licenseTypeName: {
      type: String,
      default: ''
    },
    amount: {
      type: Number,
      default: 0
    },
    originalAmount: {
      type: Number,
      default: 0
    },
    loadingCalc: {
      type: Boolean,
      default: false
    },
    loadingSubmit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      versionList: [],
      diffList: [],
      introList: []
    }
  },
  watch: {},
  computed: {
    ...mapGetters(['softPrice'])
  },
  created() {
    //获取版本列表
    this.getVersionList()
  },

  methods: {
    //获取版本列表
    getVersionList() {
      this.loading = true
      API_Soft.getVersions({
        product: this.utils.getProductCode(),
        licenseType: 'Network'
      }).then(res => {
        this.loading = false
        this.versionList = res.data.list
        this.diffList = res.data.diffs_new
        this.introList = res.data.intros
      })
    }
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', ' background:#eee;')
  }
}
</script>
<style lang="scss" scoped>
// ------------------------------------------------------网页样式------------------------------------------------------
.buy-center {
  padding-bottom: 78px;
  .title {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    img {
      width: 36px;
      margin-left: 20px;
    }
    h3 {
      font-size: 20px;
      margin-left: 20px;
      margin-bottom: 0;
    }
    .tag {
      padding: 5px 10px;
      font-size: 14px;
      font-weight: lighter;
      color: #000;
      background: #fff;
      border: 1px #ddd solid;
      border-radius: 5px;
      margin-left: 10px;
    }
  }
}
// 底部
.buy-footer {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  background: #f4f8fb;
  padding: 20px 0;
  .box-price {
    display: flex;
    align-items: center;
    .left {
      display: flex;
      align-content: center;
    }
    .right {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 20px;
    }
    .span-price {
      font-size: 22px;
      line-height: 22px;
      font-weight: bold;
      color: #f30c0c;
    }
  }
}
// ------------------------------------------------------手机版样式------------------------------------------------------
@media screen and (max-width: 576px) {
  .buy-center {
    padding-bottom: 20px !important;
  }
  .buy-footer {
    position: static !important;
    .text-right {
      text-align: center !important;
      margin-top: 10px;
      button {
        width: 100%;
      }
    }
  }
  .title {
    padding-bottom: 20px;
    img {
      width: 24px !important;
      margin-left: 0 !important;
      // display: none !important;
    }
    h3 {
      font-size: 14px !important;
      margin-left: 5px !important;
      // display: none !important;
    }
    .tag {
      padding: 2px 5px !important;
      font-size: 12px !important;
    }
  }
}
</style>